<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="في-المساء">
<h1><span dir="rtl">في المساء</span></h1>
<p><span dir="rtl">قَضَى الشَّباب نصف النَّهار في النَّوم ولَم يشأ "مالك" إيقاظِهم بعد الَّذي سمعه منهم من أمورٍ عاشوها قبل وُصولهم.</span></p>
<p><span dir="rtl">مالِك: وأخيرًا استيقظتِ يا حياة.</span></p>
<p><span dir="rtl">ردَّت حياة: نعم وأخيرًا.</span></p>
<p><span dir="rtl">ثم سحبَت الكرسيَّ في غرفة الطّعام وجلستْ.</span></p>
<p><span dir="rtl">- جيدٌ، سأُحضر الشّاي.</span></p>
<p><span dir="rtl">- سآتي معك.</span></p>
<p><span dir="rtl">نهضَت حياة وتبعت مالك إلى المطبخ:</span></p>
<ul>
<li><span dir="rtl">أتعلمُ يا عمّ مالك! لو كان لي الخيار في اختيار طريقة حياتي لاخترتُ أن أعيشها مثلك.</span></li>
</ul>
<p><span dir="rtl">نظَرَ إليها مالِك وبيده علبة الشَّاي: حقًّا!</span></p>
<p><span dir="rtl">ثمَّ وضع بعض أوراق الشَّاي في الغلَّاية على النّار وأكمل إِعْداد الشّاي.</span></p>
<p><span dir="rtl">حياة: حقًّا.</span></p>
<p><span dir="rtl">- وماذا تعرفين عن حياة عمّك مالك؟</span></p>
<ul>
<li><p><span dir="rtl">أعرف أنَّك تعيش حياتك بِحُرّية، تقضيها بين مزرعتك ومَسْرحكَ، وهي الحياة الَّتي أتمنّاها، وبسببها رجعتُ.</span></p></li>
<li><p><span dir="rtl">هربتِ!</span></p></li>
<li><p><span dir="rtl">لا يهمّ.</span></p></li>
<li><p><span dir="rtl">لا أعرف لماذا لا تُريدين الدّراسة في الخارج مع إنها حُلم الكثيرين؟!</span></p></li>
<li><p><span dir="rtl">لكنَّه ليس حُلمي، أنا أريد أن أدرسَ في بلدي، لقد خطَّطت لتحقيق أحلامي مُسبقًا يا عمّي.</span></p></li>
<li><p><span dir="rtl">هل ما زلتِ على رأيكِ في العمل بالمَسْرح؟</span></p></li>
<li><p><span dir="rtl">أكيد، حُلم حياتي أن أعمل معكَ، والأمر بالطَّبع لن يُعجب السيّدة فخريّة، أعرف ذلك جيدًا لكنَّني سأفعل المُستحيلَ في سبيل تحقيق ذلك وإِنْ تطلَّب الأمر أن أحارب الدُّنيا، كما فعلتَ أنتَ.</span></p></li>
</ul>
<p><span dir="rtl">ردَّ مالك: صحيحٌ أنَّني حاربتُ الدُّنيا من أجل أحلامي، لكنَّني بالمقابل خَسرتُ أهمّ شيءٍ.</span></p>
<ul>
<li><p><span dir="rtl">أتقصدُ عائلتك؟</span></p></li>
<li><p><span dir="rtl">فكَّرتُ بنفسي، كنتُ أنانيًّا وركّزتُ جهدي لتحقيق أحلامي على حساب عائلتي، والآن أنا نادمٌ يا حياة.</span></p></li>
</ul>
<p><span dir="rtl">سكتتْ.</span></p>
<p><span dir="rtl">مالك: سُكّر!</span></p>
<ul>
<li><span dir="rtl">ملعقتان. <strong>كان ذلك صوت عليّ.</strong></span></li>
</ul>
<p><span dir="rtl">دخلَ إلى المطبخ وأخذ مكانه على المقعد الَّذي بجانب حياة ثمَّ قال:</span></p>
<ul>
<li><span dir="rtl">مساءُ الخير.</span></li>
</ul>
<p><span dir="rtl">وضع مالكٌ الأكواب المملوءة بالشّاي أمامهم وقال:</span></p>
<ul>
<li><span dir="rtl">ها يا حياة! أمستعدَّةٌ للمُواجهة؟</span></li>
</ul>
<p><span dir="rtl">حياة: تريد أن تتخلّص منّي بهذه السّرعة!</span></p>
<p><span dir="rtl">مالك: أتخلَّص منكِ أنتِ!</span></p>
<p><span dir="rtl">حياة: إذًا دعني أبقى هنا اليوم، وغدًا خُذْني إلى البيت.</span></p>
<p><span dir="rtl">ردّ مالك: لا يجوزُ، ترينَ حالةَ البيت!</span></p>
<p><span dir="rtl">حياة: لا أرى شيئًا.</span></p>
<p><span dir="rtl">نظرَت إلى عليّ: قُل شيئًا يا عليّ.</span></p>
<p><span dir="rtl">مالك: نعم، قُل شيئًا يا عليّ!</span></p>
<p><span dir="rtl">عليّ: معهُ حقّ، لا يجوز أن تَبقي هنا أكثر، عمّك مالك لم يعد يسكنُ وحدَه في هذا البيت بعد الآن.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch016.vue?28e8171c